import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './top/Home';
import Flow from './flow/Flow';
import Case from './case/Case';
import CaseNew from './case/CaseNew';
import CaseNewDetail from './case/CaseNewDetail';
import CaseReform from './case/CaseReform';
import CaseReformDetail from './case/CaseReformDetail';
import Staff from './staff/Staff';
import Information from './information/Information';
import Contact from './contact/Contact';
import NotFound from './top/NotFound';
import CaseOffice from './case/CaseOffice';
import CaseOfficeDetail from './case/CaseOfficeDetail';

export const RouterConfig: React.FC = () => {
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route index element={<Home />} />
          <Route path="flow" element={<Flow />} />
          <Route path="case" element={<Case />} />
          <Route path="case/new" element={<CaseNew />} />
          <Route path="case/new/detail" element={<CaseNewDetail />} />
          <Route path="case/office" element={<CaseOffice />} />
          <Route path="case/office/detail" element={<CaseOfficeDetail />} />
          <Route path="case/reform" element={<CaseReform />} />
          <Route path="case/reform/detail" element={<CaseReformDetail />} />
          <Route path="staff" element={<Staff />} />
          <Route path="information" element={<Information />} />
          <Route path="contact" element={<Contact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};
